import { inject, Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';
import { DateTime } from 'luxon';
import { map, ReplaySubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AuthenticationService {
    private readonly msalService = inject(MsalService);

    private readonly isAuthenticatedAction = new ReplaySubject<boolean>(1);
    public readonly isAuthenticated$ = this.isAuthenticatedAction.asObservable();

    constructor() {
        this.msalService
            .handleRedirectObservable()
            .pipe(
                map((authResult: AuthenticationResult | null) => {
                    if (authResult != undefined && this.isAccessTokenExpired(authResult)) {
                        this.isAuthenticatedAction.next(false);
                    }

                    this.isAuthenticatedAction.next(true);
                }),
            )
            .subscribe();
    }

    private isAccessTokenExpired(authResult: AuthenticationResult): boolean {
        if (authResult.expiresOn == null) {
            return false;
        }

        return DateTime.now() >= DateTime.fromJSDate(authResult.expiresOn);
    }
}
